<template>
  <BaseElSelect v-model="syncValue" v-bind="$attrs">
    <BaseElSelectOption
      v-for="(options) in displayOptions"
      :key="options.value"
      :value="options.value"
      :label="options.label"
    />
  </BaseElSelect>
</template>

<script>
import { useVModel } from '@vueuse/core'
import { filter } from 'lodash'
import { computed, defineComponent } from 'vue'
export default defineComponent({
  name: 'TimeUnitSelect',
  props: {
    value: {
      type: [String, Object],
      default: '',
    },
    allows: {
      type: Array,
      default: () => ['second', 'minute', 'hour', 'day', 'week', 'month', 'year'],
    },
  },
  setup (props, { emit }) {
    const syncValue = useVModel(props, 'value', emit)
    const baseOptions = [
      { label: '秒', value: 'second' },
      { label: '分', value: 'minute' },
      { label: '小時', value: 'hour' },
      { label: '天', value: 'day' },
      { label: '週', value: 'week' },
      { label: '月', value: 'month' },
      { label: '年', value: 'year' },
    ]

    const displayOptions = computed(() => {
      return filter(baseOptions, (option) => {
        return props.allows.includes(option.value)
      })
    })

    return {
      syncValue,
      displayOptions,
    }
  },
})
</script>

<style lang="postcss" scoped>

</style>
